import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const NeedVerification = (): React.ReactElement => {
  const { logout } = useAuth0();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <>
      <div>メールを確認してください</div>
      <div>
        <button onClick={handleLogout}>Logout</button>
      </div>
    </>
  );
};
